module.exports = __webpack_public_path__ + "img/barrier-short.604c0e13.svg";